import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { DataSwapResponse } from '../models/dataswap-response';
import { protectedResources } from '../auth-config';
import { environment } from 'src/environments/environment';
import { ToastService } from './toast.service';
import { LTDataSwapRequest } from '../models/lt-dataswap-request';
@Injectable()
export class LBADataswapService {
    //private baseUrl: string = "api/";
    private baseUrl: string = protectedResources.LOSTalkerAPI.endpoint;
    private actionUrl = '';
    private Url = '';
    private headers = new HttpHeaders();
  
    private errorHandler(error: HttpErrorResponse, ts: ToastService): Observable<any> {
        ts.toastCreate('An HTTP transport error occured: ' + error.url + ' ' + error.status, 'Warning', {
          keepAfterRouteChange: true,
        });
    
        if (environment.enableDebuggingTools) {
          console.error('An HTTP transport error occured: ' + error.error);
        }
    
        return throwError(() => error);
      }
  
    constructor(private http: HttpClient, private toastService: ToastService) { }


    //Generic Method with new Object, but not referenced yet
    //If Loan Number populated, calls GetLoan, specify LBADataSwap or LGDataSwap in DataSwapType field
    submitDataSwapRequest(dataswapParams: LTDataSwapRequest): Observable<DataSwapResponse[]> {
        this.actionUrl = 'DataSwap/Request';
        this.Url = this.baseUrl.concat(this.actionUrl);

        return this.http
            .post<DataSwapResponse[]>(this.Url, dataswapParams, { headers: this.headers })
            .pipe(catchError(err => this.errorHandler(err, this.toastService)));
    }
}
